import {
    ClockPlus,
    CurrencyEuro,
    EditFive,
    Eye,
    EyeOff,
    ShareSeven,
    TranslateOne,
    TrashThree,
} from "@/Icons";

export { default as TitleAndDescription } from "./TitleAndDescription.vue";
export { default as Title } from "./Title.vue";
export { default as Description } from "./Description.vue";
export { default as DetailsActions } from "./DetailsActions.vue";
export { default as ActionsSelector } from "./ActionsSelector.vue";
export { default as Sections } from "./Sections.vue";
export { default as Section } from "./Section.vue";
export { default as Divider } from "./Divider.vue";

export const SectionType = Object.freeze({
    DESCRIPTION: "description",
    PROPERTIES: "properties",
    LINKED_TO: "linked_to",
    TAGS: "tags",
    IMAGES: "images",
    ACTIVITY: "activity",
});

export const headings = {
    [SectionType.DESCRIPTION]: "components.details.headings.description",
    [SectionType.PROPERTIES]: "components.details.headings.properties",
    [SectionType.LINKED_TO]: "components.details.headings.linked_to",
    [SectionType.TAGS]: "components.details.headings.tags",
    [SectionType.IMAGES]: "components.details.headings.images",
    [SectionType.ACTIVITY]: "components.details.headings.activity",
};

export const ActionType = Object.freeze({
    EDIT: "edit",
    MAKE_PUBLIC: "make_public",
    MAKE_PRIVATE: "make_private",
    LOG_TIME: "log_time",
    LOG_MATERIAL: "log_material",
    TRANSLATE: "translate",
    SHARE: "share",
    DELETE: "delete",
});

export const EventType = Object.assign({}, ActionType, {
    CHANGE_VISIBILITY: "change_visibility",
});

export const actions = [
    {
        id: ActionType.EDIT,
        icon: EditFive,
        label: "components.details.actions.edit",
        event: EventType.EDIT,
    },
    {
        id: ActionType.MAKE_PUBLIC,
        icon: Eye,
        label: "components.details.actions.change_visibility.public",
        event: EventType.CHANGE_VISIBILITY,
    },
    {
        id: ActionType.MAKE_PRIVATE,
        icon: EyeOff,
        label: "components.details.actions.change_visibility.private",
        event: EventType.CHANGE_VISIBILITY,
    },
    {
        id: ActionType.LOG_TIME,
        icon: ClockPlus,
        label: "components.details.actions.log_time",
        event: EventType.LOG_TIME,
    },
    {
        id: ActionType.LOG_MATERIAL,
        icon: CurrencyEuro,
        label: "components.details.actions.log_material",
        event: EventType.LOG_MATERIAL,
    },
    {
        id: ActionType.TRANSLATE,
        icon: TranslateOne,
        label: "components.details.actions.translate",
        event: EventType.TRANSLATE,
    },
    {
        id: ActionType.SHARE,
        icon: ShareSeven,
        label: "components.details.actions.share",
        event: EventType.SHARE,
    },
    {
        id: ActionType.DELETE,
        icon: TrashThree,
        label: "components.details.actions.delete",
        variant: "destructiveOutline",
        color: "text-button-primary-error-bg",
        event: EventType.DELETE,
    },
];
